<ng-container
  *ngrxLet="
    product$ as product;
    error as e;
    complete as isCompleted;
    suspenseTpl: loading
  "
>
  @if (e) {
    <dp-internal-server-error
      (onReloadClick)="reloadPage()"
    ></dp-internal-server-error>
  } @else if (isCompleted && product) {
    <dp-download-details-page-content
      [download]="product"
      backLinkLabel="Zusatz-Software"
      backLinkUrl="../../lists/products"
    ></dp-download-details-page-content>
  } @else {
    <ng-container *ngTemplateOutlet="loading"></ng-container>
  }
</ng-container>

<ng-template #loading>
  <div class="pt-4 flex content-center justify-center">
    <download-portal-loader></download-portal-loader>
  </div>
</ng-template>
